import axios from "axios";

// Create axios instance
const AxiosInstance = axios.create({
  // baseURL: "http://192.168.1.46:8000",
  baseURL: "https://ai.camascent.com/",
  timeout: 30000, // 30 seconds timeout for audio processing
});

export const sendVoiceMessage = async (audioFile) => {
  if (!audioFile) return "";

  const formData = new FormData();
  formData.append("audio", audioFile);

  try {
    const res = await AxiosInstance.post("/api/translate", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-Api-Key": "x5sMtuMQm580phJFAsJaliF7b",
      },
    });

    const data = res.data;

    const transcribedText =
      data.payload.text ||
      data.payload.transcription ||
      "No transcription found";

    return transcribedText;
  } catch (error) {
    console.error("Transcription error:", error);
    return "Hello How Are You";
  }
};

export default AxiosInstance;
